import { Pipe, PipeTransform } from '@angular/core';
import { Dokument } from '../../../../shared/models/dokument';

@Pipe({
  name: 'isZUSDokument',
  standalone: true,
})
export class IsZUSDokumentPipe implements PipeTransform {
  transform(document: Dokument | null | undefined): boolean {
    return document?.typDokumentu?.kod === 'ZUS';
  }
}
